import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoModule } from '@jsverse/transloco';
import { DocumentationService } from '../../core/services/documentation.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'pixl-api-documentation',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslocoModule
  ],
  templateUrl: './api-documentation.component.html',
  styleUrl: './api-documentation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApiDocumentationComponent implements OnInit {
  private documentationService = inject(DocumentationService);

  public readonly isLoading = signal<boolean>(false);
  public readonly hasError = signal<boolean>(false);

  ngOnInit(): void {
    this.openDocumentation();
  }

  public openDocumentation(): void {
    if (environment.isLocal) {
      const docUrl = `${environment.backendUrl}/api/v2/documentation`;
      window.open(docUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    this.isLoading.set(true);
    this.hasError.set(false);

    this.documentationService.getDocumentationAuthUrl().subscribe({
      next: (response) => {
        this.isLoading.set(false);
        if (response.url) {
          window.open(response.url, '_blank', 'noopener,noreferrer');
        }
      },
      error: () => {
        this.isLoading.set(false);
        this.hasError.set(true);
      }
    });
  }
}
